<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="称重单号">
                <a-input v-model.trim="queryParam.weighingNo" placeholder="请输入"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button> -->
      <a-button type="dashed" v-if="config.hasAlert" @click="tableOption">{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table 
      :adtivezz="activezz"
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1600 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="ppp">
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <!-- <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical"/> -->
        <a @click="handleDetail(record)">详情</a>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { weighingLogPage } from '@/api/logistics'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import storage from "@/utils/storage"
import queryMixin from '@/mixins/queryMixin'

export default {
  name: 'Privillege',
  mixins: [queryMixin],
  components: {
    STable
  },
  data () {
    return {
      visible: false,
      form: this.$form.createForm(this),
      mdl: {},
      activezz: 0,
      ppp:{
        pageSize: 36
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: null,
      // 表头
      columns: [
        {
          title: '物流单号',
          dataIndex: 'logisticsNo',
          width: '200px',
          fixed: 'left'
        },
        {
          title: '车号',
          dataIndex: 'vehicleNo',
          width: '130px',
        },
        {
          title: '秤台名称',
          dataIndex: 'scaleName',
          width: '130px',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '130px',
        },
        {
          title: '重量',
          dataIndex: 'weighing',
          width: '100px',
        },
        {
          title: '最大重量',
          dataIndex: 'maxWeight',
          width: '100px',
        },
        {
          title: '初稳',
          dataIndex: 'firstStopWeight',
          width: '100px',
        },
        {
          title: '终稳',
          dataIndex: 'stopWgtEnd',
          width: '100px',
        },
        {
          title: '最大稳定',
          dataIndex: 'stopWgtMax',
          width: '100px',
        },
        {
          title: '在秤时间',
          dataIndex: 'onTime',
          width: '100px',
        },
        {
          title: '称重单号',
          dataIndex: 'weighingNo',
          width: '160px',
        },
        {
          title: '操作',
          width: '50px',
          fixed: 'right',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter['pageSize'] = 500
        parameter['pageNumber'] = 1
        return weighingLogPage(Object.assign(parameter, this.queryParam))
          .then(res => {
            res.data.pageSize = res.data.totalCount
            this.pageSize = res.data.totalCount
            this.activezz++
            return res.data
          })
      },

      selectedRowKeys: [],
      selectedRows: [],
      
      // custom table alert & rowSelection
      options: {
        alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created () {
    this.tableOption()
    this.loadSelect()

    // 初始化查询条件
    this.queryParam = this.queryParam || {}
  },
  methods: {
    moment,
    loadSelect () { // 从后台拉去下拉列表数据
      
    },
    filterOption (input, option) { // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleDetail (record) {
      storage.save("cache-WeighingLogDetail", JSON.stringify(record));
      this.$router.push({name: "WeighingLogDetail"})
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>
